import { useSelector } from 'react-redux';

const useRoles = (roles) => {
    const session = useSelector((state) => state.session.session);

    if (roles[0] === '*') {
        return true;
    }

    return roles.includes(session.role_id);
};

export default useRoles;
